import { BaseFlowNodeContainer } from "../Shared/BaseFlowNodeContainer/BaseFlowNodeContainer";
import { BottomHandle } from "../Shared/FlowNodeHandles";
import { RightHandle } from "../Shared/FlowNodeHandles/MultiBottomHandle";

type NodeProps = {
    isConnectable: boolean;
    selected: boolean;
    children: JSX.Element;
    connectingNodesFrom: string | null;
    isHorizontal?: boolean;
    className?: string;
};
export const InputNode = ({
    isConnectable,
    isHorizontal,
    selected,
    children,
    connectingNodesFrom,
    className,
}: NodeProps) => {
    return (
        <BaseFlowNodeContainer selected={selected} connectingNodesFrom={!!connectingNodesFrom} className={className}>
            <>
                {children}
                {isHorizontal ? (
                    <RightHandle isConnectable={isConnectable} />
                ) : (
                    <BottomHandle isConnectable={isConnectable} />
                )}
            </>
        </BaseFlowNodeContainer>
    );
};
